import * as React from 'react';

import { ReportTypes } from '@showbie-socrative/socrative-utils';

import { translate } from '~l10n/client';

import { IncludeExplanations, ReportOptionType } from '../ReportOption';
import {
  AssessmentsCommonProps,
  AssessmentsExportReportsPanel,
} from './AssessmentsExportReportsPanel';

const AssessmentsExportReportsSummary = (props: AssessmentsCommonProps) => {
  const reportOptions: ReportOptionType[] = [IncludeExplanations];
  return (
    <AssessmentsExportReportsPanel
      {...props}
      description={translate(
        'Export a PDF summarizing student responses and correct answers on a question-by-question basis.'
      )}
      title={translate('Results Summary PDF')}
      reportOptions={reportOptions}
      initialOptions={props.initialOptions}
      reportRequestSelectedType={ReportTypes.QuestionSpecificPDF}
    />
  );
};

export { AssessmentsExportReportsSummary };
export default AssessmentsExportReportsSummary;
